<script>
import {EventBus} from "@/helpers/event-bus";
import {authComputed} from "@/state/helpers";

export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    ...authComputed,

    getRoutePath() {
      return this.$route.fullPath;
    }
  },
  methods: {
    checkUsersOnline(users) {
      const onlineUsers = [];
      const now = Math.floor(this.$moment.now() / 1000);
      for (const user of users) {
        if (user.id !== this.getUser.uid && user.path === this.getRoutePath) {
          onlineUsers.push(user);
          if (user.time < now) {
            this.$ref
          }
        }
      }

      this.users = onlineUsers;
    },
  },
  mounted() {
    EventBus.$on('onlineUsers', (users) => {
      this.checkUsersOnline(users)
    });
  },
  beforeDestroy() {
    EventBus.$off('onlineUsers');
  },
  data() {
    return {
      users: []
    }
  }
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center ">
        <h4 class="mb-0 font-size-18">{{ title }}</h4>
        <!-- online page -->
        <div v-if="users.length > 0" class="d-flex align-items-center ms-3">
          <span class="pb-0 mb-0 me-1 text-dark font-size-11">{{ $t("current_online") }}</span>
          <div v-for="user in users" :key="user.id">
            <div class="media rounded-pill p-1 ps-2 pe-2"
                 :class="{
                  'bg-dark': `${user.role}` === 'operator',
                  'bg-danger': `${user.role}` === 'admin',
                  'bg-info': `${user.role}` === 'marketing',
                 }"
            >
              <div class="avatar-xs">
                    <span
                        class="avatar-title rounded-circle font-size-13 bg-white"
                        :class="{
                          'text-dark': `${user.role}` === 'operator',
                          'text-danger': `${user.role}` === 'admin',
                          'text-info': `${user.role}` === 'marketing',
                        }"
                    >{{ user.initials || '-'}}</span>
              </div>
              <div class="media-body ms-1 text-white font-size-12">
                <p class="p-0 m-0"><b>{{ user.name }}</b> <small>({{ user.role }})</small></p>
                <small>{{ user.time | moment('lll') }}</small>
              </div>
            </div>
          </div>
        </div>


        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
